import React from 'react'
import PrimaryHeader from '../components/PrimaryHeader'
import Hero from '../components/Hero'
import image1 from '../images/bg.jpg'
import About from '../components/About'
import Contact from '../components/Contact'
import PrimaryFooter from '../components/PrimaryFooter'

const Primary = () => {
  return (
    <div
      id='home'
      style={{
        backgroundImage: 'url(' + image1 + ')',
        backgroundRepeat: 'repeat',
        backgroundAttachment: 'fixed'
      }}
      className='w-screen2222 bg-cover'
    >
      <PrimaryHeader />
      <Hero />
      <About />
      <Contact />
      <PrimaryFooter />
    </div>
  )
}

export default Primary
